/* eslint-disable */

import router from "../../router";

const state = {
  isValidated: false,
};

const getters = {
  getAuthStatus: () => state.isValidated,
};

const actions = {
  async userAuth({ commit }, payload) {
    if (!payload.logout) {
      const getHash = (arg) => {
        if (arg == "path") return payload.name ? "organizer" : "token";

        const typ = String(
          payload.name ? "organizer" : payload.login_type
        ).toLowerCase()[0];

        if (arg == "typ") return typ;

        const lgn = {
          o: "lgn", //organizer
          a: "lgn", //agent
          v: "vtr", //voter
        };

        if (arg == "lgn") return lgn[typ];

        if (arg == "usr")
          return payload.name ? "organizer" : payload.login_type;
      };

      const url = `${process.env.VUE_APP_BACKEND_API_ENDPOINT}`;

      const response = await fetch(`${url}/${getHash("path")}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const jsonBody = await response.json();

        if (jsonBody.success) {
          const { token } = jsonBody.data;
          const usr = jsonBody.data[getHash("usr")];
          localStorage.setItem("tkn", token);
          localStorage.setItem("usr", JSON.stringify(usr));
          localStorage.setItem(
            "typ",
            `${getHash("typ")}${token.substr(token.length / 2, 10)}`
          );
          localStorage.setItem("lgn", `${getHash("lgn")}`);

          commit("SET_AUTHENTICATION_STATUS", true);
          return true;
        } else return jsonBody;
      }
    } else {
      commit("SET_AUTHENTICATION_STATUS", false);
      return true;
    }

    return { success: false, message: "Failed! Try again later." };
  },
};

const mutations = {
  SET_AUTHENTICATION_STATUS(state, value) {
    if (value) {
      state.isValidated = true;
      if (localStorage.getItem("lgn") == "lgn")
        router.push({ name: "PollsPage" });
    } else {
      localStorage.clear();
      router.history.go();
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
